module.exports = __webpack_public_path__ + "static/media/voucherRed.c5d24877.png";